import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import setCategorySortByOperation from 'store/category/operation/setCategorySortByOperation';
import setCategoryPageNrOperation from 'store/category/operation/setCategoryPageNrOperation';
import { setCategoryRefetchFlagAction } from 'store/category/slice';
import updateCategoryQueryStringOperation from 'store/category/operation/updateCategoryQueryStringOperation';
import { useTranslation } from 'react-i18next';
import gtmSendEvent, { gtmChangeSortingEvent } from 'utils/gtm/gtmSendEvent';
import getCategorySortBy from 'store/category/selector/getCategorySortBy';
import DropdownSelect from 'components/Common/DropdownSelect/DropdownSelect';

const DropdownSort: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const sortBy = useSelector(getCategorySortBy);

  const changeSortBy = (sort: number) => {
    gtmSendEvent(gtmChangeSortingEvent(sort));
    dispatch(setCategorySortByOperation(sort));
    dispatch(setCategoryPageNrOperation(1));
    dispatch(setCategoryRefetchFlagAction(true));
    dispatch(updateCategoryQueryStringOperation(history));
  };

  const { t } = useTranslation();
  const sortOptions = [
    {
      title: t('txt_sort_by_popular_and_new'),
      value: 6,
    },
    {
      title: t('txt_sort_by_most_popular'),
      value: 1,
    },
    {
      title: t('txt_sort_by_new'),
      value: 2,
    },
  ];

  return (
    <>
      <DropdownSelect
        label={t('txt_sort_by')}
        titleDecorator={t}
        options={sortOptions}
        selected={sortBy}
        onChange={changeSortBy}
      />
    </>
  );
};

export default DropdownSort;
